import React, { Component } from 'react';
import './styles.css';

class RedCentralCircle extends Component {
	render() {
		return (
			<div className="stepper-item-layout-red-central-circle">
				{this.props.children}
			</div>
		);
	}
}

export default RedCentralCircle;
